import { Routes } from '@angular/router';

import { ERoutes, UtilityRoutes, getCategoryRouteSegment } from '../../types/app-routes';
import {
  CATEGORY_AWARD,
  ECategoryAward,
} from '../../../schema/hasura/main/cls-category-award.schema';
import { EStatusAwardRequest } from '../../../schema/hasura/main/cls-status-award.schema';
import { CardCanDeactivateGuard } from '../../services/card-can-deactivate-guard.service';

const createCategoryRedirectRoutes = (module: ERoutes, categoryCode: ECategoryAward): Routes => [
  {
    path: categoryCode,
    pathMatch: 'full',
    redirectTo: getCategoryRouteSegment(module, categoryCode),
  },
  {
    path: `${categoryCode}/${UtilityRoutes.CARD}`,
    redirectTo: `${getCategoryRouteSegment(module, categoryCode)}/${UtilityRoutes.CARD}`,
  },
];

export const awardRequestRoutes: Routes = [
  {
    path: ERoutes.AWARD_REQUEST,
    children: [
      ...createCategoryRedirectRoutes(ERoutes.AWARD_REQUEST, ECategoryAward.STATE),
      ...createCategoryRedirectRoutes(ERoutes.AWARD_REQUEST, ECategoryAward.REGIONAL),
      ...createCategoryRedirectRoutes(ERoutes.AWARD_REQUEST, ECategoryAward.ENCOURAGEMENT),

      {
        path: getCategoryRouteSegment(ERoutes.AWARD_REQUEST, ECategoryAward.STATE),
        data: {
          categoryCode: ECategoryAward.STATE,
          categoryTitle: CATEGORY_AWARD.STATE,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./award-request-table/award-request-table.component').then(
                (m) => m.AwardRequestTableComponent
              ),
          },
          {
            path: 'card',
            canDeactivate: [CardCanDeactivateGuard],
            loadComponent: () =>
              import('./award-request-card/award-request-card.component').then(
                (m) => m.AwardRequestCardComponent
              ),
          },
        ],
      },

      {
        path: getCategoryRouteSegment(ERoutes.AWARD_REQUEST, ECategoryAward.REGIONAL),
        data: {
          categoryCode: ECategoryAward.REGIONAL,
          categoryTitle: CATEGORY_AWARD.REGIONAL,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./award-request-table/award-request-table.component').then(
                (m) => m.AwardRequestTableComponent
              ),
          },
          {
            path: 'card',
            canDeactivate: [CardCanDeactivateGuard],
            loadComponent: () =>
              import('./award-request-card/award-request-card.component').then(
                (m) => m.AwardRequestCardComponent
              ),
          },
        ],
      },

      {
        path: getCategoryRouteSegment(ERoutes.AWARD_REQUEST, ECategoryAward.ENCOURAGEMENT),
        data: {
          categoryCode: ECategoryAward.ENCOURAGEMENT,
          categoryTitle: CATEGORY_AWARD.ENCOURAGEMENT,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./award-request-table/award-request-table.component').then(
                (m) => m.AwardRequestTableComponent
              ),
          },
          {
            path: 'card',
            canDeactivate: [CardCanDeactivateGuard],
            loadComponent: () =>
              import('./award-request-card/award-request-card.component').then(
                (m) => m.AwardRequestCardComponent
              ),
          },
        ],
      },
    ],
  },
];

export const awardRequestArchiveRoutes: Routes = [
  {
    path: ERoutes.AWARD_REQUEST_ARCHIVE,
    children: [
      ...createCategoryRedirectRoutes(ERoutes.AWARD_REQUEST_ARCHIVE, ECategoryAward.STATE),
      ...createCategoryRedirectRoutes(ERoutes.AWARD_REQUEST_ARCHIVE, ECategoryAward.REGIONAL),
      ...createCategoryRedirectRoutes(ERoutes.AWARD_REQUEST_ARCHIVE, ECategoryAward.ENCOURAGEMENT),

      {
        path: getCategoryRouteSegment(ERoutes.AWARD_REQUEST_ARCHIVE, ECategoryAward.STATE),
        data: {
          categoryCode: ECategoryAward.STATE,
          categoryTitle: CATEGORY_AWARD.STATE,
          isArchive: true,
          archiveStatusCode: EStatusAwardRequest.ARCHIVED_STATE,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./award-request-table/award-request-table.component').then(
                (m) => m.AwardRequestTableComponent
              ),
          },
          {
            path: 'card',
            canDeactivate: [CardCanDeactivateGuard],
            loadComponent: () =>
              import('./award-request-card/award-request-card.component').then(
                (m) => m.AwardRequestCardComponent
              ),
          },
        ],
      },

      {
        path: getCategoryRouteSegment(ERoutes.AWARD_REQUEST_ARCHIVE, ECategoryAward.REGIONAL),
        data: {
          categoryCode: ECategoryAward.REGIONAL,
          categoryTitle: CATEGORY_AWARD.REGIONAL,
          isArchive: true,
          archiveStatusCode: EStatusAwardRequest.ARCHIVED_REGIONAL,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./award-request-table/award-request-table.component').then(
                (m) => m.AwardRequestTableComponent
              ),
          },
          {
            path: 'card',
            canDeactivate: [CardCanDeactivateGuard],
            loadComponent: () =>
              import('./award-request-card/award-request-card.component').then(
                (m) => m.AwardRequestCardComponent
              ),
          },
        ],
      },

      {
        path: getCategoryRouteSegment(ERoutes.AWARD_REQUEST_ARCHIVE, ECategoryAward.ENCOURAGEMENT),
        data: {
          categoryCode: ECategoryAward.ENCOURAGEMENT,
          categoryTitle: CATEGORY_AWARD.ENCOURAGEMENT,
          isArchive: true,
          archiveStatusCode: EStatusAwardRequest.ARCHIVED_ENCOURAGEMENT,
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./award-request-table/award-request-table.component').then(
                (m) => m.AwardRequestTableComponent
              ),
          },
          {
            path: 'card',
            canDeactivate: [CardCanDeactivateGuard],
            loadComponent: () =>
              import('./award-request-card/award-request-card.component').then(
                (m) => m.AwardRequestCardComponent
              ),
          },
        ],
      },
    ],
  },
];
